<template>
        <v-jumbotron
    src="/static/signup.png"
    height='1000px'
    dark
  >
  <v-container>

    <v-layout>
      <v-flex xs12 sm6 offset-sm3>
                <v-card>
          <v-card-text>
            <v-container>
              <v-btn @click='googleSignup'>google Auth</v-btn>
            </v-container>
          </v-card-text>
        </v-card>
        <v-card>
          <v-card-text>
            <v-container>
              <form @submit.prevent='onSignup'>
                <v-layout row>
                  <v-flex xs12>
                    <v-text-field
                      name ='email'
                      label='Mail'
                      id='email'
                      v-model='email'
                      type='email'
                      required>
                    </v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs12>
                    <v-text-field
                      name='password'
                      label='Password'
                      id='password'
                      v-model='password'
                      type='password'
                      required>
                    </v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs12>
                    <v-text-field
                      name='confirmPassword'
                      label='Confirm Password'
                      id='confirmPassword'
                      v-model='confirmPassword'
                      type='password'
                      :rules='[comparePasswords]'
                      required>
                    </v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs12>
                    <v-btn type='submit'>Sign Up</v-btn>
                  </v-flex>
                </v-layout>
              </form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
  </v-jumbotron>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex'
  export default {
    data () {
      return {
        email: '',
        password: '',
        confirmPassword: ''
      }
    },
    computed: {
      ...mapGetters('user', {
        user: 'user'
      }),
      comparePasswords () {
        return this.password === this.confirmPassword ? true : 'Passwords do not match'
      }
    },
    watch: {
      user (value) {
        if (value !== null && value !== undefined) {
          this.$router.push('/userinfo')
        }
      }
    },
    methods: {
      ...mapActions('user', {
        google: 'googleSignUp',
        emailPassword: 'signUpUser'
      }),
      onSignup () {
        // this.$store.dispatch('signUpUser', {email: this.email, password: this.password})
        this.emailPassword({email: this.email, password: this.password})
      },
      googleSignup () {
        // this.$store.dispatch('googleSignUp')
        this.google()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/user/SignUp.vue